import { render } from "./AddProgramWithEntity.vue?vue&type=template&id=5ba61fee&scoped=true&ts=true"
import script from "./AddProgramWithEntity.vue?vue&type=script&lang=ts"
export * from "./AddProgramWithEntity.vue?vue&type=script&lang=ts"

import "./AddProgramWithEntity.vue?vue&type=style&index=0&id=5ba61fee&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba61fee"]])

export default __exports__